import StopsScreen from './StopsScreen';

export default StopsScreen;
